import { Pipe, PipeTransform } from '@angular/core';
import { TimeRangeName } from '~core/models/shared.models';

@Pipe({
  name: 'timeRange',
  pure: true,
  standalone: true
})
export class TimeRangePipe implements PipeTransform {
  private readonly _timeRangeMap: Record<TimeRangeName, string> = {
    [TimeRangeName.TODAY]: "Aujourd'hui",
    [TimeRangeName.ANYTIME]: 'Depuis toujours',
    [TimeRangeName.LAST_THREE_MINUTE]: 'Dernières 3 minutes',
    [TimeRangeName.LAST_HOUR]: 'Dernière heure',
    [TimeRangeName.LAST_DAY]: 'Hier',
    [TimeRangeName.LAST_THREE_DAYS]: '3 derniers jours',
    [TimeRangeName.LAST_WEEK]: 'Semaine dernière',
    [TimeRangeName.LAST_MONTH]: 'Mois dernier',
    [TimeRangeName.LAST_THREE_MONTHS]: '3 derniers mois',
    [TimeRangeName.LAST_YEAR]: 'Année dernière',
    [TimeRangeName.CURRENT_WEEK]: 'Cette semaine',
    [TimeRangeName.CURRENT_MONTH]: 'Ce mois-ci',
    [TimeRangeName.CURRENT_YEAR]: 'Cette année',
    [TimeRangeName.CUSTOM]: 'Personnalisé'
  };

  transform(timeRange: TimeRangeName | string): string {
    return this._timeRangeMap[timeRange as TimeRangeName] || timeRange;
  }
}
